import type { OutcomeDefinition } from "@repo/app-types/entities/outcome";
import type { SampleToolResultOutcomeGradingsPayload } from "@repo/app-types/entities/playbookNodeSampleToolResult";
import { Size } from "@repo/ui/helpers/helpers";
import { SlideoverContainer } from "@repo/ui/Slideover/slideoverContainer";
import {
  SlideoverDialog,
  SlideoverDialogContent,
  SlideoverDialogTitleHeader,
} from "@repo/ui/Slideover/slideoverDialog";
import type { FC } from "react";
import { OutcomeSampleGradingsTable } from "./outcomeSampleGradingsTable.js";

interface OutcomeGradedCallsSlideoverProps {
  isOpen: boolean;
  onClose: () => void;
  gradings: SampleToolResultOutcomeGradingsPayload | undefined;
  outcomeDefinition: OutcomeDefinition;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Outcomes have no per-call feedback, so this slideover shows a single
 * "sample calls" view (no feedback tab).
 */
export const OutcomeGradedCallsSlideover: FC<
  OutcomeGradedCallsSlideoverProps
> = ({ isOpen, onClose, gradings, outcomeDefinition, isLoading, isError }) => {
  return (
    <SlideoverContainer
      isOpen={isOpen}
      onOpenChange={(newIsOpen) => {
        if (!newIsOpen) {
          onClose();
        }
      }}
      isDismissable
      size={Size.LARGE}
    >
      <SlideoverDialog label="Graded calls">
        <SlideoverDialogTitleHeader>Graded calls</SlideoverDialogTitleHeader>
        <SlideoverDialogContent>
          <p className="px-4 py-2 text-sm text-muted-foreground">
            Calls automatically selected and regraded to test this outcome
            update against the current baseline.
          </p>
          <OutcomeSampleGradingsTable
            entries={gradings?.sample_grades ?? []}
            outcomeDefinition={outcomeDefinition}
            isLoading={isLoading}
            isError={isError}
          />
        </SlideoverDialogContent>
      </SlideoverDialog>
    </SlideoverContainer>
  );
};
